import api from "@/config/api";
import { log } from "@/utils/logger";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

const useUsageModal = () => {
    const { oid } = useParams();
    const queryClient = useQueryClient();
    const [loading, setLoading] = useState(false);

    const onReset = async () => {
        try {
            setLoading(true);
            await api.put(`/organizations/${oid}/subscription/reset-labels`);
            await queryClient.refetchQueries({ queryKey: ["organization", oid], exact: true });

            log.success("Labels have been reset successfully.");
        } catch (e) {
            log.error(e);
        } finally {
            setLoading(false);
        }
    };

    return {
        onReset,
        loading,
    };
};

export { useUsageModal };
